module.exports = __webpack_public_path__ + "static/media/Group 1500@3x.59361708.png";